module.exports = __webpack_public_path__ + "static/hero-logo-row-2-2da8aff2eabff582e5ce4f7b6677ba8a.png";